export const firebaseConfig = {
    apiKey: "AIzaSyACr6D5jdoY87a5v1PZhv-qoUl_XZfx7Uk",
    authDomain: "byeaccent-f29ee.firebaseapp.com",
    databaseURL: "https://byeaccent-f29ee.firebaseio.com",
    projectId: "byeaccent-f29ee",
    storageBucket: "byeaccent-f29ee.appspot.com",
    messagingSenderId: "862111453467",
    appId: "1:862111453467:web:4cf29a7c086aca6f1e03be",
    measurementId: "G-TMGM8Q3GQS"
};